import _ from 'underscore';

import preferences from 'Preferences';
import {BenchlingAction} from 'redux-stores/Action';
import {BenchlingState} from 'redux-stores/reduceApp';

import {CodonOptimizationPreferences, CodonOptimizationSelectionTab} from './CodonOptimizationConstants';
import {CodonOptimizationTabActionType} from './CodonOptimizationTabReduxActions';
import reduceCodonOptimizationTab, {
  CodonOptimizationTabState,
  INITIAL_STATE,
} from './reduceCodonOptimizationTab';

export interface CodonOptimizationTabsState {
  [tabId: string]: CodonOptimizationTabState;
}

export class CodonOptimizationTabsSelector {
  private state: CodonOptimizationTabsState;

  constructor(state: BenchlingState) {
    this.state = state.ui.codonOptimizationTab;
  }

  getState(tabId: string): CodonOptimizationTabState {
    return this.state[tabId];
  }
}

export const CODON_OPTIMIZATION_TABS_INITIAL_STATE: CodonOptimizationTabsState = {};

export default function reduceAllCodonOptimizationTabs(
  state: CodonOptimizationTabsState = CODON_OPTIMIZATION_TABS_INITIAL_STATE,
  action: BenchlingAction
): CodonOptimizationTabsState {
  switch (action.type) {
    case CodonOptimizationTabActionType.NEW_TAB:
      return {
        ...state,
        [action.tabId]: {
          ...INITIAL_STATE,
          activeTab: CodonOptimizationSelectionTab.AVOIDED_CUTSITES,
          selectedOrganism: preferences.get(CodonOptimizationPreferences.ORGANISM),
          selectedGCLevel: preferences.get(CodonOptimizationPreferences.GC_LEVEL),
          cutsitesToAvoid: preferences.get(CodonOptimizationPreferences.CUTSITES),
          uridineDepletion: preferences.get(CodonOptimizationPreferences.URIDINE),
          avoidHairpins: preferences.get(CodonOptimizationPreferences.AVOID_HAIRPINS),
          hairpinStem: preferences.get(CodonOptimizationPreferences.HAIRPIN_STEM),
          hairpinWindow: preferences.get(CodonOptimizationPreferences.HAIRPIN_WINDOW),
          patternsToReduce: preferences.get(CodonOptimizationPreferences.REDUCE_PATTERNS),
        },
      };
    case CodonOptimizationTabActionType.CLOSE_OPTIMIZATION:
    case CodonOptimizationTabActionType.SAVE_OPTIMIZATION_COMPLETED:
      // eslint-disable-next-line no-restricted-syntax
      return _.omit(state, [action.tabId]);
    case CodonOptimizationTabActionType.GO_BACK:
    case CodonOptimizationTabActionType.PREVIEW_COMPLETED:
    case CodonOptimizationTabActionType.PREVIEW_ERROR:
    case CodonOptimizationTabActionType.PREVIEW_PENDING:
    case CodonOptimizationTabActionType.UPDATE_SELECTED_GC_LEVEL:
    case CodonOptimizationTabActionType.UPDATE_SELECTED_ORGANISM:
    case CodonOptimizationTabActionType.SET_SELECTION:
    case CodonOptimizationTabActionType.ADD_PROTECTED_REGION:
    case CodonOptimizationTabActionType.DELETE_ALL_PROTECTED_REGIONS:
    case CodonOptimizationTabActionType.DELETE_PROTECTED_REGION:
    case CodonOptimizationTabActionType.IS_INVALID_PROTECTED_REGION:
    case CodonOptimizationTabActionType.ADD_CUTSITE_TO_AVOID:
    case CodonOptimizationTabActionType.DELETE_ALL_CUTSITES_TO_AVOID:
    case CodonOptimizationTabActionType.DELETE_CUTSITE_TO_AVOID:
    case CodonOptimizationTabActionType.ADD_CUTSITE_TO_PRESERVE:
    case CodonOptimizationTabActionType.DELETE_ALL_CUTSITES_TO_PRESERVE:
    case CodonOptimizationTabActionType.DELETE_CUTSITE_TO_PRESERVE:
    case CodonOptimizationTabActionType.UPDATE_URIDINE_DEPLETION:
    case CodonOptimizationTabActionType.UPDATE_HAIRPIN_PARAMETERS:
    case CodonOptimizationTabActionType.UPDATE_ACTIVE_TAB:
    case CodonOptimizationTabActionType.ADD_PATTERN_TO_REDUCE:
    case CodonOptimizationTabActionType.DELETE_ALL_PATTERNS_TO_REDUCE:
    case CodonOptimizationTabActionType.DELETE_PATTERN_TO_REDUCE:
    case CodonOptimizationTabActionType.UPDATE_PATTERN_TO_REDUCE:
      return {...state, [action.tabId]: reduceCodonOptimizationTab(state[action.tabId], action)};
    default:
      return state;
  }
}
